module.exports = __webpack_public_path__ + "static/media/sc.78b9ed6d.svg";